import {URL_BASE_API } from '../configs/urlConfigs';

import service from './api';

export const crewList = (request) => {     
    let ENDPOINT = '';
    if(request.data && request.data.applyFilter && request.data.applyFilter > 0) {
        let search   = request.data.search;
        let csvDownload   = request.data.csvDownload ? Number(request.data.csvDownload) : 0; 
        let column   = request.data.column;   
        let pageId   = request.data.page;
        let pageSize = request.data.pageSize; 

        if(csvDownload > 0) {
            ENDPOINT = URL_BASE_API+'user/crew-profiles/?page=0&column='+column+'&search='+search;
        }
        else if(column||pageId||search||pageSize){
            ENDPOINT = URL_BASE_API+'user/crew-profiles/?page='+pageId+'&column='+column+'&search='+search+'&page_size='+pageSize;
        }   
        ENDPOINT += '&filter=1'; 

        let filtersData = request.data.filtersData; 
        
        let skillIds = 0; 
        let departmentIds = 0; 
        if(filtersData.skillIds && filtersData.skillIds.length)  skillIds = JSON.stringify(filtersData.skillIds); 
        if(skillIds)  ENDPOINT += '&skills='+skillIds; 

        if(filtersData.departments && filtersData.departments.length)  departmentIds = JSON.stringify(filtersData.departments); 
        if(departmentIds)  ENDPOINT += '&departments='+departmentIds; 

        if(filtersData.is_chief.length)     ENDPOINT += '&is_chief='+filtersData.is_chief; 
        if(filtersData.is_inducted.length)  ENDPOINT += '&is_inducted='+filtersData.is_inducted; 
        if(filtersData.is_approved.length)  ENDPOINT += '&is_approved='+filtersData.is_approved; 
        if(filtersData.is_active.length)    ENDPOINT += '&is_active='+filtersData.is_active; 
        if(filtersData.has_vehicle.length)  ENDPOINT += '&has_vehicle='+filtersData.has_vehicle; 
        if(filtersData.is_available.length) ENDPOINT += '&is_available='+filtersData.is_available;
        if(filtersData.is_omnu.length)      ENDPOINT += '&is_omnu='+filtersData.is_omnu;
        if(filtersData.date_type.length)    ENDPOINT += '&date_type='+filtersData.date_type+'&from_date='+filtersData.from_date+'&to_date='+filtersData.to_date; 

    }
    else if(request.data!==undefined){  
        let csvDownload   = request.data.csvDownload ? Number(request.data.csvDownload) : 0; 
        let search   = request.data.search;
        let column   = request.data.column;   
        let pageId   = request.data.page;
        let pageSize = request.data.pageSize; 
        if(csvDownload > 0) {
            ENDPOINT = URL_BASE_API+'user/crew-profiles/?page=0&column='+column+'&search='+search; 
        }
        else if(column||pageId||search||pageSize){
            ENDPOINT = URL_BASE_API+'user/crew-profiles/?page='+pageId+'&column='+column+'&search='+search+'&page_size='+pageSize;
        }   
    }else{
        ENDPOINT = URL_BASE_API+'user/crew-profiles/';
    }  
    return service.get(ENDPOINT);  
    
}; 

export const crewAllList = (request) => {  
    const ENDPOINT = URL_BASE_API+'user/crew-list';
  
    return service.get(ENDPOINT);
}

export const crewEdit = (request) => {
    let crewId = request.data;
    const ENDPOINT = URL_BASE_API+'user/crew-profile/'+crewId;
    return service.get(ENDPOINT);  
}; 

export const crewBasicInfoAdd = (request) => {
    const ENDPOINT = URL_BASE_API+'user/crew-profiles/';
  
    return service.post(ENDPOINT,request.data);
    
}; 

export const crewBasicInfoUpdate = (request) => {
    let crewId     = request.data.get('id');
    const ENDPOINT = URL_BASE_API+'user/crew-profile/'+crewId;
    request.data.delete('id');

    return service.put(ENDPOINT,request.data);  
    
}; 

export const crewAvailability = (request) => {
    let crewId = request.data.profileId;
    const ENDPOINT = URL_BASE_API+'user/change-crew-availability/'+crewId;
    delete request.data.profileId;
    return service.put(ENDPOINT,request.data);   
};

export const crewApprove = (request) => {
    let crewId = request.data.profileId;
    const ENDPOINT = URL_BASE_API+'user/crew-approve-status/'+crewId;
    delete request.data.profileId;
    return service.put(ENDPOINT,request.data);   
};

export const chiefEligibility = (request) => {
    let crewId = request.data.profileId;
    const ENDPOINT = URL_BASE_API+'user/crew-chief-status/'+crewId;
    delete request.data.profileId;
    return service.put(ENDPOINT,request.data);   
};

export const crewDelete = (request) => {
    let crewId = request.data.profileId;
    const ENDPOINT = URL_BASE_API+'user/change-crew-status/'+crewId;
    delete request.data.profileId;
    return service.put(ENDPOINT,request.data);   
};

export const crewSkillList = (request) => {
    const ENDPOINT = URL_BASE_API+'user/crew-skills/?crew_id='+request.data+'&column=skill_name';
    return service.get(ENDPOINT);   
};

export const crewSkillSave = (request) => {
    const ENDPOINT = URL_BASE_API+'user/crew-skills/';
    return service.post(ENDPOINT,request.data);   
};

export const crewCsvImport = (request) => {
    const ENDPOINT = URL_BASE_API+'affiliate/import-client-crew/';
    return service.post(ENDPOINT,request.data);   
};

export const crewScheduleShiftStatus = (request) => {
    let shiftId = request.data.shiftId;
    let status = request.data.status;
    let crewId = request.data.profileId;
    let dataObj = {"schedule_user_status":status, "crew_profile_id":crewId}; 
    const ENDPOINT = URL_BASE_API+'crew/change-scheduled-shift-status/'+shiftId;
    return service.put(ENDPOINT,dataObj);   
};

export const crewScheduleShiftCheckIn = (request) => {
    let shiftId = request.data.shiftId;
    let checkin = request.data.checkin;
    let crewId = request.data.profileId; // {"checkin_datetime":"2020-06-29T12:49:34+00:00", "crew_profile_id":1}
    let dataObj = {"checkin_datetime":checkin, "crew_profile_id":crewId}; 
    const ENDPOINT = URL_BASE_API+'crew/check-in-out-status-change/'+shiftId;
    return service.put(ENDPOINT,dataObj);   
}; 

export const crewScheduleShiftCheckOut = (request) => {
    let shiftId  = request.data.shiftId;
    let checkout = request.data.checkout;
    let crewId   = request.data.profileId; // {"checkout_datetime":"2020-06-29T12:49:34+00:00", "crew_profile_id":1}
    let dataObj = {"checkout_datetime":checkout, "crew_profile_id":crewId}; 
    const ENDPOINT = URL_BASE_API+'crew/check-in-out-status-change/'+shiftId;
    return service.put(ENDPOINT,dataObj);   
};

export const crewRemovalFromShift = (request) => {
    const ENDPOINT = URL_BASE_API+'affiliate/remove-scheduled-crew/'+request.data.schedule_shift_id;
    return service.put(ENDPOINT);   
};

export const crewInduction = (request) => {
    let crewId = request.data.profileId;
    const ENDPOINT = URL_BASE_API+'user/crew-induct-status/'+crewId;
    delete request.data.profileId;
    return service.put(ENDPOINT,request.data);   
};

export const crewTimesheetList = (request) => {
    let crew_id     = request.data.crew_id;
    let pageNum     = request.data.page;
    let pageSize    = request.data.pageSize; 
    const ENDPOINT  = URL_BASE_API+'events/get-time-sheet-data-shift/?crew_id='+crew_id+'&page='+pageNum+'&page_size='+pageSize; 
    return service.get(ENDPOINT);   
};

export const crewFeedbackList = (request) => {
    let crew_id     = request.data.crew_id;
    let pageNum     = request.data.page;
    let pageSize    = request.data.pageSize; 
    const ENDPOINT  = URL_BASE_API+'events/get-crew-feedback-details/?crew_id='+crew_id+'&page='+pageNum+'&page_size='+pageSize; 
    return service.get(ENDPOINT); 
};
export const crewUnapprovedCount = (request) => { 
    const ENDPOINT  = URL_BASE_API+'user/crew-unapproved_count/'; 
    return service.get(ENDPOINT); 
};

export const crewNotesList = (request) => { 
    let crew_id     = request.data.crew_id;
    let pageNum     = request.data.page;
    let pageSize    = request.data.pageSize; 
    const ENDPOINT  = URL_BASE_API+'user/crew-note/?crew='+crew_id+'&page='+pageNum+'&page_size='+pageSize; 
    return service.get(ENDPOINT); 
};

export const crewNotesAdd = (request) => { 
    const ENDPOINT = URL_BASE_API+'user/crew-note/';
    return service.post(ENDPOINT,request.data);   
};

export const crewNotesDocumentAdd = (request) => {
    const ENDPOINT = URL_BASE_API+'user/crew-note-doc/';
    return service.post(ENDPOINT,request.data);  
};

export const crewNotesDocumentDelete = (request) => { 
    let crew_note_doc_id     = request.data.crew_note_doc_id;
    const ENDPOINT = URL_BASE_API+'user/crew-note-doc/'+crew_note_doc_id;
    return service.delete(ENDPOINT,request.data);   
};

